import { SplitPaymentCC } from './SplitPaymentCC';
export default SplitPaymentCC